<template>
  <nav :class="['landing-navbar', { 'scrolled': isScrolled }]">
    <div class="navbar-container">
      <div class="navbar-content">
        <!-- Logo -->
        <router-link
          to="/home"
          class="navbar-brand"
        >
          <div class="brand-icon">
            <img
              src="@/assets/images/logo/osaslogo.png"
              alt="NC Logo"
              class="nc-logo"
            >
          </div>
          <span class="brand-text">NC OSAS</span>
        </router-link>

        <!-- Desktop Navigation -->
        <div class="nav-desktop">
          <router-link
            to="/home"
            class="nav-link"
          >
            Home
          </router-link>

          <router-link
            to="/about"
            class="nav-link"
          >
            About
          </router-link>

          <!-- Services Dropdown -->
          <div class="dropdown">
            <button
              class="nav-link dropdown-toggle"
              @click.stop="toggleDropdownLocal('services')"
            >
              Services
              <i class="fas fa-chevron-down dropdown-icon" />
            </button>
            <div
              v-show="activeDropdownLocal === 'services'"
              class="dropdown-menu show"
            >
              <router-link
                to="/services/student-welfare"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-hands-helping item-icon green" />
                Student Welfare
              </router-link>
              <router-link
                to="/services/student-development"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-users item-icon green" />
                Student Development
              </router-link>
              <router-link
                to="/services/health-wellness"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-heartbeat item-icon green" />
                Health & Wellness
              </router-link>
              <router-link
                to="/services/counseling"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-heart item-icon green" />
                Counseling
              </router-link>
              <router-link
                to="/services/career"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-briefcase item-icon green" />
                Career Services
              </router-link>
            </div>
          </div>

          <!-- More Dropdown -->
          <div class="dropdown">
            <button
              class="nav-link dropdown-toggle"
              @click.stop="toggleDropdownLocal('more')"
            >
              More
              <i class="fas fa-chevron-down dropdown-icon" />
            </button>
            <div
              v-show="activeDropdownLocal === 'more'"
              class="dropdown-menu dropdown-right show"
            >
              <router-link
                to="/services/community"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-people-arrows item-icon yellow" />
                Community
              </router-link>
              <router-link
                to="/services/lost-found"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-search item-icon yellow" />
                Lost & Found
              </router-link>
              <router-link
                to="/services/records"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-folder-open item-icon yellow" />
                Records
              </router-link>
              <router-link
                to="/support"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-life-ring item-icon yellow" />
                Support Services
              </router-link>
              <router-link
                to="/policies"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-file-alt item-icon yellow" />
                Policies & Forms
              </router-link>
              <router-link
                to="/events"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-calendar-alt item-icon yellow" />
                Events
              </router-link>
              <router-link
                to="/programs"
                class="dropdown-item"
                @click.native="closeDropdown"
              >
                <i class="fas fa-graduation-cap item-icon yellow" />
                Programs
              </router-link>
            </div>
          </div>

          <!-- FAQ & Contact -->
          <router-link
            to="/home/faqs"
            class="nav-link"
          >
            FAQ
          </router-link>

          <router-link
            to="/home/contact"
            class="nav-link"
          >
            Contact
          </router-link>

          <router-link
            :to="loginActionRoute"
            class="btn-login"
          >
            <i :class="['fas', isAuthenticated ? 'fa-tachometer-alt' : 'fa-sign-in-alt']" />
            {{ loginActionLabel }}
          </router-link>
        </div>

        <!-- Mobile Menu Toggle -->
        <button
          class="mobile-toggle"
          @click="$emit('toggle-mobile-menu')"
        >
          <i :class="['fas', mobileMenuOpen ? 'fa-times' : 'fa-bars']" />
        </button>
      </div>

      <!-- Mobile Navigation -->
      <div
        v-if="mobileMenuOpen"
        class="nav-mobile"
      >
        <router-link
          to="/home"
          class="mobile-link"
          @click.native="$emit('toggle-mobile-menu')"
        >
          <i class="fas fa-home" />
          Home
        </router-link>
        <router-link
          to="/about"
          class="mobile-link"
          @click.native="$emit('toggle-mobile-menu')"
        >
          <i class="fas fa-info-circle" />
          About
        </router-link>
        <router-link
          to="/services/student-welfare"
          class="mobile-link"
          @click.native="$emit('toggle-mobile-menu')"
        >
          <i class="fas fa-hands-helping" />
          Student Welfare
        </router-link>
        <router-link
          to="/services/health-wellness"
          class="mobile-link"
          @click.native="$emit('toggle-mobile-menu')"
        >
          <i class="fas fa-heartbeat" />
          Health & Wellness
        </router-link>
        <router-link
          to="/services/career"
          class="mobile-link"
          @click.native="$emit('toggle-mobile-menu')"
        >
          <i class="fas fa-briefcase" />
          Career Services
        </router-link>
        <router-link
          to="/services/lost-found"
          class="mobile-link"
          @click.native="$emit('toggle-mobile-menu')"
        >
          <i class="fas fa-search" />
          Lost & Found
        </router-link>
        <router-link
          to="/home/faqs"
          class="mobile-link"
          @click.native="$emit('toggle-mobile-menu')"
        >
          <i class="fas fa-question-circle" />
          FAQ
        </router-link>
        <router-link
          to="/home/contact"
          class="mobile-link"
          @click.native="$emit('toggle-mobile-menu')"
        >
          <i class="fas fa-envelope" />
          Contact
        </router-link>
        <router-link
          :to="loginActionRoute"
          class="mobile-login-btn"
          @click.native="$emit('toggle-mobile-menu')"
        >
          <i :class="['fas', isAuthenticated ? 'fa-tachometer-alt' : 'fa-sign-in-alt']" />
          {{ loginActionLabel }}
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

import { getHomeRouteByRoleCode } from '@/config/roles'

export default {
  name: 'LandingNavbar',
  props: {
    mobileMenuOpen: {
      type: Boolean,
      default: false
    },
    isScrolled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      activeDropdownLocal: null
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      token: 'auth/token'
    }),

    isAuthenticated () {
      return !!this.user?.id && !!this.token
    },

    dashboardRouteName () {
      if (!this.isAuthenticated) {
        return 'shared.login'
      }

      return getHomeRouteByRoleCode(this.user)
    },

    loginActionLabel () {
      return this.dashboardRouteName !== 'shared.login' ? 'Dashboard' : 'Login'
    },

    loginActionRoute () {
      return { name: this.dashboardRouteName }
    }
  },

  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },

  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },

  methods: {
    handleClickOutside (event) {
      if (!event.target.closest('.dropdown')) {
        this.activeDropdownLocal = null
      }
    },

    toggleDropdownLocal (name) {
      this.activeDropdownLocal = this.activeDropdownLocal === name ? null : name
    },

    closeDropdown () {
      this.activeDropdownLocal = null
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/landing/layout/navbar.css';
</style>
